<!-- Tool Description Card-->
<app-material
    class="description"
    [style]="toolDescriptionMaterialStyle"
    [isLoading]="isLoading">
    <div class="header" header>
        <h5>{{ 'admin.tools.details.detailsPage.sections.toolDescription' | translate }}</h5>
        <app-icon *ngIf="shouldRenderModifiers()" library="fontawesome" variant="fa-edit"
                  (click)="openDescriptionModal()"></app-icon>
    </div>
    <div class="body" body>
        <app-display-label
            label="{{'admin.tools.details.header.details-labels.toolName' | translate}}"
            [value]="selectedTool?.name">
        </app-display-label>
        <app-display-label
            label="{{'admin.tools.details.detailsPage.labels.description' | translate}}"
            [value]="selectedTool?.details?.description">
        </app-display-label>
        <app-display-label
            label="{{'admin.tools.details.header.details-labels.codingType' | translate}}"
            [value]="getCodingTypeLabel()">
        </app-display-label>
        <app-display-label
            label="{{'admin.tools.details.header.details-labels.toolCode' | translate}}"
            [value]="selectedTool?.mesCode">
        </app-display-label>
        <app-display-label
            label="{{'admin.tools.details.header.details-labels.toolControlName' | translate}}"
            [value]="selectedTool?.toolControlName">
        </app-display-label>
        <app-display-label
            label="{{'admin.tools.details.detailsPage.labels.toolNumber' | translate}}"
            [value]="selectedTool?.idFromSet">
        </app-display-label>
        <app-display-label
            label="{{'admin.tools.details.header.details-labels.supplierCode' | translate}}"
            [value]="selectedTool?.supplierCode">
        </app-display-label>
        <app-display-label
            label="{{'admin.tools.details.header.details-labels.inventoryNumber' | translate}}"
            [value]="selectedTool?.inventoryNumber">
        </app-display-label>
        <app-display-label label="{{'admin.tools.details.detailsPage.labels.isSpare' | translate}}"
                           [value]="selectedTool?.details?.isSpare">
        </app-display-label>
        <app-display-label label="{{'admin.tools.details.header.details-labels.owner' | translate}}"
                           [value]="selectedTool?.owner?.name">
        </app-display-label>
    </div>
    <ng-container footer #materialFooter>
    </ng-container>
</app-material>

<app-description-form-modal
    [isLoading]="isLoading"
    [tool]="toolCopy"
    [owners]="owners"
    (updateDescription)="onUpdateToolDetails($event)">
</app-description-form-modal>

<!-- Tool Storage Card-->
<app-material
    class="storage"
    [style]="toolDescriptionMaterialStyle"
    [isLoading]="isLoading">
    <div class="header" header>
        <h5>{{ 'admin.tools.details.detailsPage.sections.toolStorage' | translate }}</h5>
    </div>
    <div class="body" body>
        <app-display-label
            label="{{'admin.tools.details.header.details-labels.liftShelf' | translate}}"
            [value]="trayName">
        </app-display-label>
        <app-display-label
            label="{{'admin.tools.details.header.details-labels.liftNumber' | translate}}"
            [value]="liftName">
        </app-display-label>
        <app-display-label
            label="{{'admin.tools.details.header.details-labels.shelfPosition' | translate}}"
            [value]="slotName">
        </app-display-label>
        <app-display-label
            label="{{'admin.tools.details.header.details-labels.cart' | translate}}"
            [value]="selectedTool?.cart">
        </app-display-label>
    </div>
    <ng-container footer #materialFooter>
    </ng-container>
</app-material>

<!-- Tool Identification Card-->
<app-material
    class="identification"
    [style]="toolSpecialIdentifierMaterialStyle"
    [isLoading]="isLoading">
    <div class="header" header>
        <h5>{{ 'admin.tools.details.detailsPage.sections.toolSpecialIdentification' | translate }}</h5>
        <app-icon *ngIf="shouldRenderModifiers()" library="fontawesome" variant="fa-edit"
                  (click)="openSpecialIdentificationsModal()"></app-icon>
    </div>
    <div class="body" body>
        <div class="tool-special-identification">
            <app-tooltip
                type="info"
                tooltipPosition="top"
                [record]="'admin.tools.details.detailsPage.tooltips.monitoredInSAP' | translate">
            </app-tooltip>
            <app-display-label
                label="{{'admin.tools.details.detailsPage.labels.monitoredInSAP' | translate}}"
                [value]="selectedTool?.details?.isToolLifeMonitoredInSap"
                [inlineLabel]="true">
            </app-display-label>
        </div>
        <div class="tool-special-identification">
            <app-tooltip
                type="info"
                tooltipPosition="top"
                [record]="'admin.tools.details.detailsPage.tooltips.monitoredInMES' | translate">
            </app-tooltip>
            <app-display-label
                label="{{'admin.tools.details.detailsPage.labels.monitoredInMES' | translate}}"
                [value]="selectedTool?.details?.isToolLifeMonitoredInMes"
                [inlineLabel]="true">
            </app-display-label>
        </div>
        <div class="tool-special-identification">
            <app-tooltip
                type="info"
                tooltipPosition="top"
                [record]="'admin.tools.details.detailsPage.tooltips.monitoredInPLC' | translate">
            </app-tooltip>
            <app-display-label
                label="{{'admin.tools.details.detailsPage.labels.monitoredInPLC' | translate}}"
                [value]="selectedTool?.details?.isToolLifeMonitoredInPlc"
                [inlineLabel]="true">
            </app-display-label>
        </div>
        <div class="tool-special-identification">
            <app-tooltip
                type="info"
                tooltipPosition="top"
                [record]="'admin.tools.details.detailsPage.tooltips.hasMaintenaceAtLine' | translate">
            </app-tooltip>
            <app-display-label
                label="{{'admin.tools.details.detailsPage.labels.hasMaintenaceAtLine' | translate}}"
                [value]="selectedTool?.details?.hasMaintenaceAtLine"
                [inlineLabel]="true">
            </app-display-label>
        </div>
        <div class="tool-special-identification">
            <app-tooltip
                type="info"
                tooltipPosition="left"
                [record]="'admin.tools.details.detailsPage.tooltips.excludedFromMaintenance' | translate">
            </app-tooltip>
            <app-display-label
                label="{{'admin.tools.details.detailsPage.labels.excludedFromMaintenance' | translate}}"
                [value]="selectedTool?.details?.excludedFromMaintenance"
                [inlineLabel]="true">
            </app-display-label>
        </div>
        <div class="tool-special-identification">
            <app-tooltip
                type="info"
                tooltipPosition="top"
                [record]="'admin.tools.details.detailsPage.tooltips.isToolStationedAtERSA' | translate">
            </app-tooltip>
            <app-display-label
                label="{{'admin.tools.details.detailsPage.labels.isToolStationedAtERSA' | translate}}"
                [value]="selectedTool?.details?.isToolStationedAtERSA"
                [inlineLabel]="true">
            </app-display-label>
        </div>
        <div class="tool-special-identification">
            <app-tooltip
                type="info"
                tooltipPosition="top"
                [record]="'admin.tools.details.detailsPage.tooltips.excludedFromReturn' | translate">
            </app-tooltip>
            <app-display-label
                label="{{'admin.tools.details.detailsPage.labels.excludedFromReturn' | translate}}"
                [value]="selectedTool?.details?.excludedFromReturn"
                [inlineLabel]="true">
            </app-display-label>
        </div>
    </div>
</app-material>

<!-- Tool Special Identifiers Card-->
<app-special-identifiers-form-modal
    [isLoading]="isLoading"
    [toolDetails]="toolDetails"
    (updateSpecialIdentifiers)="onUpdateToolDetails($event)">
</app-special-identifiers-form-modal>

<!-- Tool Lifecycle  Card-->
<app-material
    class="life"
    [style]="toolLifecycleMaterialStyle"
    [isLoading]="isLoading">
    <div class="header" header>
        <h5>{{ 'admin.tools.details.detailsPage.sections.toolLifecycle' | translate }}</h5>
        <app-icon *ngIf="shouldRenderModifiers()" library="fontawesome" variant="fa-edit"
                  (click)="openLifecycleModal()"></app-icon>
    </div>
    <div class="body" body>
        <div class="lifecycle-info-line">
            <app-tooltip
                type="info"
                tooltipPosition="top"
                [record]="'admin.tools.details.detailsPage.tooltips.toolExpirationDate' | translate">
            </app-tooltip>
            <app-display-label
                label="{{'admin.tools.details.detailsPage.labels.toolExpirationDate' | translate}}"
                [value]="expirationDateLabel"
                [inlineLabel]="true"
                [style.color]="expirationStyles.textColor">
            </app-display-label>
            <app-tooltip #expirationTooltip
                         class='expiration-tooltip'
                         *ngIf="remainingDaysExpiration || remainingDaysExpiration === 0"
                         [type]="expirationStyles.tooltipStyle"
                         tooltipPosition="top"
                         [record]="expirationStyles.warningMessage">
            </app-tooltip>
        </div>
        <div class="lifecycle-info-line">
            <app-tooltip
                type="info"
                tooltipPosition="top"
                [record]="'admin.tools.details.detailsPage.tooltips.lifecycleTotal' | translate">
            </app-tooltip>
            <app-display-label
                label="{{'admin.tools.details.detailsPage.labels.lifecycleTotal' | translate}}"
                [value]=totalLifeCyclesLabel
                [inlineLabel]="true">
            </app-display-label>

        </div>
        <div class="lifecycle-info-line">
            <app-tooltip
                type="info"
                tooltipPosition="top"
                [record]="'admin.tools.details.detailsPage.tooltips.lifeTimeTotal' | translate">
            </app-tooltip>
            <app-display-label
                label="{{'admin.tools.details.detailsPage.labels.lifeTimeTotal' | translate}}"
                [value]="totalLifeTimeLabel"
                [inlineLabel]="true">
            </app-display-label>
        </div>
        <div class="lifecycle-info-line">
            <app-tooltip
                type="info"
                tooltipPosition="top"
                [record]="'admin.tools.details.detailsPage.tooltips.resetCounter' | translate">
            </app-tooltip>
            <app-display-label
                label="{{ 'admin.tools.details.detailsPage.labels.revisionPercent' | translate }}"
                [value]="selectedTool?.details?.toolRevisionPercent"
                [inlineLabel]="true">
            </app-display-label>
        </div>
        <div class="lifecycle-info-line">
            <app-tooltip
                type="info"
                tooltipPosition="top"
                [record]="'admin.tools.details.detailsPage.tooltips.partNumbersCount' | translate">
            </app-tooltip>
            <app-display-label
                label="{{'admin.tools.details.detailsPage.labels.partNumbersCount' | translate}}"
                [value]="selectedTool?.details?.partNumbersCount"
                [inlineLabel]="true">
            </app-display-label>
        </div>
    </div>
    <ng-container #materialFooter></ng-container>
</app-material>
<app-lifecycle-form-modal
    [isLoading]="isLoading"
    [toolDetails]="toolDetails"
    (updateLifecycle)="onUpdateToolDetails($event)">
</app-lifecycle-form-modal>


<!-- Tool Request/Returns Card -->
<app-material
    class="requests"
    [style]="toolLifecycleMaterialStyle"
    [isLoading]="isLoading">
    <div class="header" header>
        <h5>{{ 'admin.tools.details.detailsPage.sections.toolRequests' | translate }}</h5>
    </div>
    <ng-container body>
        <app-display-label label="{{'admin.tools.details.detailsPage.labels.lastLineToolRequest' | translate}}"
                           [value]="lastLineRequest?.createdDate | date:'dd-MM-yyyy hh:mm a'"
                           [hasHyperlinkValue]='true'
                           [inlineLabel]="true"
                           (onHyperlinkClick)="openLastRequest(lastLineRequest)">
        </app-display-label>
        <app-display-label label="{{'admin.tools.details.detailsPage.labels.lastLineToolReturn' | translate}}"
                           [value]="lastLineReturn?.createdDate | date:'dd-MM-yyyy hh:mm a'"
                           [hasHyperlinkValue]='true'
                           [inlineLabel]="true"
                           (onHyperlinkClick)="openLastReturn(lastLineReturn)">
        </app-display-label>

        <app-display-label label="{{'admin.tools.details.detailsPage.labels.lastFacilityToolRequest' | translate}}"
                           [value]="lastFacilityRequest?.createdDate | date:'dd-MM-yyyy hh:mm a'"
                           [hasHyperlinkValue]='true'
                           [inlineLabel]="true"
                           (onHyperlinkClick)="openLastRequest(lastFacilityRequest)">
        </app-display-label>

        <app-display-label label="{{'admin.tools.details.detailsPage.labels.lastFacilityToolReturn' | translate}}"
                           [value]="lastFacilityReturn?.createdDate | date:'dd-MM-yyyy hh:mm a'"
                           [hasHyperlinkValue]='true'
                           [inlineLabel]="true"
                           (onHyperlinkClick)="openLastReturn(lastFacilityReturn)">
        </app-display-label>
    </ng-container>
</app-material>
<app-lifecycle-form-modal
    [isLoading]="isLoading"
    [toolDetails]="toolDetails"
    (updateLifecycle)="onUpdateToolDetails($event)">
</app-lifecycle-form-modal>


<!-- Tool Part Number  Card-->
<app-material
    class="partNumbers"
    [style]="toolConfigMaterialStyle"
    [isLoading]="isLoading">
    <div class="header" header>
        <h5>{{ 'admin.tools.details.detailsPage.labels.partNumbers' | translate }}</h5>
        <app-icon *ngIf="shouldRenderModifiers()" library="fontawesome" variant="fa-edit"
                  (click)="openToolConfigWizard()"></app-icon>
    </div>
    <div class="body" body>
        <app-listbox [items]="selectedTool?.details?.partNumberLabel"
                     [isMaterial]="false"
                     [emptyMessage]="'admin.tools.details.detailsPage.labels.noPartNumber' | translate">
        </app-listbox>
    </div>
</app-material>

<!-- Tool Equipment Card-->
<app-material
    class="equipment"
    [class.no-spi]="!selectedTool?.details?.mainLine?.isSPI"
    [style]="toolConfigMaterialStyle"
    [isLoading]="isLoading">
    <div class="header" header>
        <h5>{{ 'admin.tools.details.detailsPage.labels.equipment'| translate }}</h5>
        <app-icon *ngIf="shouldRenderModifiers()" library="fontawesome" variant="fa-edit"
                  (click)="openToolConfigWizard()">
        </app-icon>
    </div>
    <div class="body" body>
        <app-equipment-tree
            [loading]="isLoading"
            [isMaterial]="false"
            [displayField]="'name'"
            [labelClass]="'highlighted'"
            [items]="selectedTool?.details?.equipment">
        </app-equipment-tree>
    </div>
</app-material>

<!-- Tool Insertion Cycles  Card-->
<app-material
    *ngIf="selectedTool?.details?.mainLine?.isSPI"
    class="insertionCycles"
    [style]="toolConfigMaterialStyle"
    [isLoading]="isLoading">
    <div class="header" header>
        <h5>{{ 'admin.tools.details.detailsPage.labels.insertionCycles' | translate }}</h5>
        <app-icon *ngIf="shouldRenderModifiers()" library="fontawesome" variant="fa-edit"
                  (click)="openToolConfigWizard()">
        </app-icon>
    </div>
    <div class="body" body>
        <app-listbox [items]="selectedTool?.details?.insertionCycles || []"
                     [isMaterial]="false"
                     [emptyMessage]="'admin.tools.details.detailsPage.labels.noInsertionCycles' | translate">
        </app-listbox>
    </div>
</app-material>

<app-tool-config-wizard></app-tool-config-wizard>
<app-pending-tool-requests-modal label='admin.tools.details.detailsPage.labels.lastToolRequest'>
</app-pending-tool-requests-modal>
<app-pending-tool-returns-modal label='admin.tools.details.detailsPage.labels.lastToolReturn'>
</app-pending-tool-returns-modal>
